import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class WebPaymentMethodReferenceService extends BaseReferenceService {
  constructor() {
    super('WebPaymentMethodReference');
  }
}
